module.exports = __webpack_public_path__ + "static/media/Koch Equity Development.22971e74.svg";